module.exports = __webpack_public_path__ + "img/2f_l_twodays.ca2c7666.png";